import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	.layout-modal {
		.modal-container-wrapper {
			width: auto;
			overflow: hidden;

			.modal-container {
				.modal-header {
					background: transparent
						linear-gradient(180deg, #b9944a 0%, #d0bc94 100%) 0% 0%;
					height: 62px;
					border-radius: 0 0 35px 0;

					display: flex;
					justify-content: flex-start;
					padding-left: 2em;

					.modal-header-title {
						font-size: 20px;
						color: ${variables.colorWhite};
						font-weight: ${variables.fontBold};
					}
				}

				.modal-body {
					display: flex;
					justify-content: center;
					align-items: center;

					.panel-form-user-login {
						padding: 0;
						box-shadow: none;
					}
				}
			}
			.modal-close-button {
				background-color: transparent;
				box-shadow: none;
				opacity: 1;
				border: 1px solid #ffffff;
				border-radius: 5px;

				.icon {
					background-image: url('/images/cart/x-white.svg');
					margin: 5px 0 0 0;
				}

				&:hover {
					box-shadow: none;
					background-color: white;

					.icon {
						filter: invert(1);
					}
				}
			}
		}
	}

	@media all and (max-width: ${variables.tabletS}) {
		.layout-modal {
			.modal-container-wrapper {
				width: 90%;
			}
		}
	}
`;
